// extracted by mini-css-extract-plugin
module.exports = {"para":"privacy-policy_para__ggjfg","heading":"privacy-policy_heading__MwQqP","heading-top":"privacy-policy_heading-top__j8Gw5"};